module.exports = __webpack_public_path__ + "img/logo-white@2x.afb879b4.png";